//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets data.
 * @param orderedFrom (optional) 
 * @param orderedTo (optional) 
 * @param deliveryDateFrom (optional) 
 * @param deliveryDateTo (optional) 
 * @param order (optional) 
 * @param reference (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function get(orderedFrom?: Date | null | undefined, orderedTo?: Date | null | undefined, deliveryDateFrom?: Date | null | undefined, deliveryDateTo?: Date | null | undefined, order?: string | null | undefined, reference?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ResponseOrderListDto> {
    let url_ = getBaseUrl() + "/api/order-list?";
    if (orderedFrom !== undefined && orderedFrom !== null)
        url_ += "OrderedFrom=" + encodeURIComponent(orderedFrom ? "" + Types.formatDate(orderedFrom) : "") + "&";
    if (orderedTo !== undefined && orderedTo !== null)
        url_ += "OrderedTo=" + encodeURIComponent(orderedTo ? "" + Types.formatDate(orderedTo) : "") + "&";
    if (deliveryDateFrom !== undefined && deliveryDateFrom !== null)
        url_ += "DeliveryDateFrom=" + encodeURIComponent(deliveryDateFrom ? "" + Types.formatDate(deliveryDateFrom) : "") + "&";
    if (deliveryDateTo !== undefined && deliveryDateTo !== null)
        url_ += "DeliveryDateTo=" + encodeURIComponent(deliveryDateTo ? "" + Types.formatDate(deliveryDateTo) : "") + "&";
    if (order !== undefined && order !== null)
        url_ += "Order=" + encodeURIComponent("" + order) + "&";
    if (reference !== undefined && reference !== null)
        url_ += "Reference=" + encodeURIComponent("" + reference) + "&";
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder === null)
        throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGet,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGet?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGet(_response);
    });
}

function processGet(response: AxiosResponse): Promise<Types.ResponseOrderListDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initResponseOrderListDto(resultData200);
        return Promise.resolve<Types.ResponseOrderListDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ResponseOrderListDto>(null as any);
}
let _requestConfigGet: Partial<AxiosRequestConfig> | null;
export function getGetRequestConfig() {
  return _requestConfigGet;
}
export function setGetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGet = value;
}
export function patchGetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGet = patch(_requestConfigGet ?? {});
}